var map = {
	"./AboutUs.vue": [
		"2089",
		"view-AboutUs-vue"
	],
	"./Admin/Administrators/EditUser.vue": [
		"675d",
		"view-Admin-Administrators-EditUser-vue"
	],
	"./Admin/Administrators/List.vue": [
		"e2fc",
		"view-Admin-Administrators-List-vue"
	],
	"./Admin/ChangeNick.vue": [
		"5657",
		"view-Admin-ChangeNick-vue"
	],
	"./Admin/ChangePassword.vue": [
		"d948",
		"view-Admin-ChangePassword-vue"
	],
	"./Admin/ChangeToPremium.vue": [
		"0b3b",
		"view-Admin-ChangeToPremium-vue"
	],
	"./Admin/ClearImages.vue": [
		"958b2",
		"view-Admin-ClearImages-vue"
	],
	"./Admin/Country/List.vue": [
		"f46d",
		"view-Admin-Country-List-vue"
	],
	"./Admin/Slider/Delete.vue": [
		"c898",
		"view-Admin-Slider-Delete-vue"
	],
	"./Admin/Slider/EditCreate.vue": [
		"e0a1",
		"view-Admin-Slider-EditCreate-vue"
	],
	"./Admin/Slider/List.vue": [
		"b80a",
		"view-Admin-Slider-List-vue"
	],
	"./Admin/Tutorial/List.vue": [
		"43bc",
		"view-Admin-Tutorial-List-vue"
	],
	"./Admin/UpdateData.vue": [
		"d79f",
		"view-Admin-UpdateData-vue"
	],
	"./Auth/BtnsAuth.vue": [
		"ca23",
		"view-Auth-BtnsAuth-vue"
	],
	"./Auth/ChangePassword.vue": [
		"9ec3",
		"view-Auth-ChangePassword-vue"
	],
	"./Auth/Edit.vue": [
		"4d7f",
		"view-Auth-Edit-vue"
	],
	"./Auth/Home.vue": [
		"6724",
		"view-Auth-Home-vue"
	],
	"./Auth/Login.vue": [
		"7f71",
		"view-Auth-Login-vue"
	],
	"./Auth/ModalChangePsn.vue": [
		"a488",
		"view-Auth-ModalChangePsn-vue"
	],
	"./Auth/Register.vue": [
		"5a00",
		"view-Auth-Register-vue"
	],
	"./Auth/ResetPassword.vue": [
		"0bdb",
		"view-Auth-ResetPassword-vue"
	],
	"./Auth/SendLink.vue": [
		"5105",
		"view-Auth-SendLink-vue"
	],
	"./Back/Bet/BetsConfirm.vue": [
		"f96d",
		"view-Back-Bet-BetsConfirm-vue"
	],
	"./Back/Bet/CreateOrEdit.vue": [
		"60c5",
		"view-Back-Bet-CreateOrEdit-vue"
	],
	"./Back/Bet/Home.vue": [
		"62d2",
		"view-Back-Bet-Home-vue"
	],
	"./Back/Division/CustomButtons.vue": [
		"2241",
		"view-Back-Division-CustomButtons-vue"
	],
	"./Back/Division/DeliverCup.vue": [
		"9731",
		"view-Back-Division-DeliverCup-vue"
	],
	"./Back/Division/Division.vue": [
		"401a",
		"view-Back-Division-Division-vue"
	],
	"./Back/Division/Liguilla.vue": [
		"0fa7",
		"view-Back-Division-Liguilla-vue"
	],
	"./Back/Division/List.vue": [
		"c1a3",
		"view-Back-Division-List-vue"
	],
	"./Back/Division/ModalAddEdit.vue": [
		"dca2",
		"view-Back-Division-ModalAddEdit-vue"
	],
	"./Back/Division/ModalAddTeam.vue": [
		"f5ac",
		"view-Back-Division-ModalAddTeam-vue"
	],
	"./Back/Division/ModalChangeImage.vue": [
		"b947",
		"view-Back-Division-ModalChangeImage-vue"
	],
	"./Back/Division/ModalCreateFixture.vue": [
		"95df",
		"view-Back-Division-ModalCreateFixture-vue"
	],
	"./Back/Division/ModalDateGame.vue": [
		"2611",
		"view-Back-Division-ModalDateGame-vue"
	],
	"./Back/Division/ModalFixture.vue": [
		"fd5e",
		"view-Back-Division-ModalFixture-vue"
	],
	"./Back/Division/ModalShowDate.vue": [
		"4832",
		"view-Back-Division-ModalShowDate-vue"
	],
	"./Back/Division/ModalTransfers.vue": [
		"59f4",
		"view-Back-Division-ModalTransfers-vue"
	],
	"./Back/Division/Notices/Create.vue": [
		"cdb2",
		"view-Back-Division-Notices-Create-vue"
	],
	"./Back/Division/Notices/Edit.vue": [
		"db85",
		"view-Back-Division-Notices-Edit-vue"
	],
	"./Back/Division/Notices/List.vue": [
		"eb2d",
		"view-Back-Division-Notices-List-vue"
	],
	"./Back/Division/Players.vue": [
		"f853",
		"view-Back-Division-Players-vue"
	],
	"./Back/Division/Seasons.vue": [
		"46ad",
		"view-Back-Division-Seasons-vue"
	],
	"./Back/Division/TeamWeek.vue": [
		"2c71",
		"view-Back-Division-TeamWeek-vue"
	],
	"./Back/Division/Teams.vue": [
		"8c8e",
		"view-Back-Division-Teams-vue"
	],
	"./Back/Division/partials/ItemTeamWeek.vue": [
		"9273",
		"view-Back-Division-partials-ItemTeamWeek-vue"
	],
	"./Back/Shop/Category/CreateOrEdit.vue": [
		"fb04",
		"view-Back-Shop-Category-CreateOrEdit-vue"
	],
	"./Back/Shop/Product/CreateOrEdit.vue": [
		"19d6",
		"view-Back-Shop-Product-CreateOrEdit-vue"
	],
	"./Back/Shop/SubCategory/CreateOrEdit.vue": [
		"2a93",
		"view-Back-Shop-SubCategory-CreateOrEdit-vue"
	],
	"./Back/Team/Details.vue": [
		"03e2",
		"view-Back-Team-Details-vue"
	],
	"./Back/Team/Formation.vue": [
		"ff7a",
		"view-Back-Team-Formation-vue"
	],
	"./Back/Team/Invitations.vue": [
		"451a",
		"view-Back-Team-Invitations-vue"
	],
	"./Back/Team/InvitePlayers.vue": [
		"ccfa",
		"view-Back-Team-InvitePlayers-vue"
	],
	"./Back/Team/List.vue": [
		"6023",
		"view-Back-Team-List-vue"
	],
	"./Back/Team/Managment.vue": [
		"efab",
		"view-Back-Team-Managment-vue"
	],
	"./Back/Team/ModalAddImage.vue": [
		"7b8d",
		"view-Back-Team-ModalAddImage-vue"
	],
	"./Back/Team/ModalCreate.vue": [
		"c338",
		"view-Back-Team-ModalCreate-vue"
	],
	"./Back/Team/MyFormation.vue": [
		"938f",
		"view-Back-Team-MyFormation-vue"
	],
	"./Back/Team/Notices/Create.vue": [
		"cbc3",
		"view-Back-Team-Notices-Create-vue"
	],
	"./Back/Team/Notices/Edit.vue": [
		"b665",
		"view-Back-Team-Notices-Edit-vue"
	],
	"./Back/Team/Notices/List.vue": [
		"9cd5",
		"view-Back-Team-Notices-List-vue"
	],
	"./Back/Team/Notifications.vue": [
		"7dbc",
		"view-Back-Team-Notifications-vue"
	],
	"./Back/Team/Players.vue": [
		"4bf5",
		"view-Back-Team-Players-vue"
	],
	"./Back/Team/Results/ChangeResults.vue": [
		"9369",
		"view-Back-Team-Results-ChangeResults-vue"
	],
	"./Back/Team/Results/Edit.vue": [
		"c8c4",
		"view-Back-Team-Results-Edit-vue"
	],
	"./Back/Team/Results/EditMatch.vue": [
		"72d7",
		"view-Back-Team-Results-EditMatch-vue"
	],
	"./Back/Team/Results/EditStatisticsResult.vue": [
		"4de9",
		"view-Back-Team-Results-EditStatisticsResult-vue"
	],
	"./Back/Team/Results/Home.vue": [
		"671a",
		"view-Back-Team-Results-Home-vue"
	],
	"./Back/Team/Results/ModalAddStatistics.vue": [
		"3ced",
		"view-Back-Team-Results-ModalAddStatistics-vue"
	],
	"./Back/Team/Results/ModalImages.vue": [
		"717b",
		"view-Back-Team-Results-ModalImages-vue"
	],
	"./Back/Team/Results/ModalVideos.vue": [
		"31b9",
		"view-Back-Team-Results-ModalVideos-vue"
	],
	"./Back/Team/Results/Players.vue": [
		"dc98",
		"view-Back-Team-Results-Players-vue"
	],
	"./Back/Team/SelectTraining.vue": [
		"82b7",
		"view-Back-Team-SelectTraining-vue"
	],
	"./Back/Team/Tshirts.vue": [
		"9659",
		"view-Back-Team-Tshirts-vue"
	],
	"./Back/Team/partials/ModalChangeName.vue": [
		"c275",
		"view-Back-Team-partials-ModalChangeName-vue"
	],
	"./Back/Team/partials/ModalChangeResults.vue": [
		"b148",
		"view-Back-Team-partials-ModalChangeResults-vue"
	],
	"./Back/Team/partials/ModalEnabledStatistic.vue": [
		"edda",
		"view-Back-Team-partials-ModalEnabledStatistic-vue"
	],
	"./Back/Team/partials/SeekerMatches.vue": [
		"5dec",
		"view-Back-Team-partials-SeekerMatches-vue"
	],
	"./Back/Team/partials/TableResults.vue": [
		"dc16",
		"view-Back-Team-partials-TableResults-vue"
	],
	"./Back/Tournament/AddEdit.vue": [
		"23b2",
		"view-Back-Tournament-AddEdit-vue"
	],
	"./Back/Tournament/AddTeam.vue": [
		"6996",
		"view-Back-Tournament-AddTeam-vue"
	],
	"./Back/Tournament/Administrators.vue": [
		"9330",
		"view-Back-Tournament-Administrators-vue"
	],
	"./Back/Tournament/Awards.vue": [
		"66c2",
		"view-Back-Tournament-Awards-vue"
	],
	"./Back/Tournament/Banners/List.vue": [
		"1462",
		"view-Back-Tournament-Banners-List-vue"
	],
	"./Back/Tournament/Banners/ModalAddEdit.vue": [
		"85f2",
		"view-Back-Tournament-Banners-ModalAddEdit-vue"
	],
	"./Back/Tournament/Categories/List.vue": [
		"73d2",
		"view-Back-Tournament-Categories-List-vue"
	],
	"./Back/Tournament/Categories/ModalAddEdit.vue": [
		"0c86",
		"view-Back-Tournament-Categories-ModalAddEdit-vue"
	],
	"./Back/Tournament/ChangeImage.vue": [
		"0324",
		"view-Back-Tournament-ChangeImage-vue"
	],
	"./Back/Tournament/CustomButtons.vue": [
		"4a4b",
		"view-Back-Tournament-CustomButtons-vue"
	],
	"./Back/Tournament/List.vue": [
		"a4d6",
		"view-Back-Tournament-List-vue"
	],
	"./Back/Tournament/ModalAddMoney.vue": [
		"79b0",
		"view-Back-Tournament-ModalAddMoney-vue"
	],
	"./Back/Tournament/ModalSignings.vue": [
		"a5a1",
		"view-Back-Tournament-ModalSignings-vue"
	],
	"./Back/Tournament/Notices/Create.vue": [
		"835a",
		"view-Back-Tournament-Notices-Create-vue"
	],
	"./Back/Tournament/Notices/Edit.vue": [
		"88f5",
		"view-Back-Tournament-Notices-Edit-vue"
	],
	"./Back/Tournament/Notices/List.vue": [
		"cd39",
		"view-Back-Tournament-Notices-List-vue"
	],
	"./Back/Tournament/Players.vue": [
		"68b5",
		"view-Back-Tournament-Players-vue"
	],
	"./Back/Tournament/Rules.vue": [
		"c5a4",
		"view-Back-Tournament-Rules-vue"
	],
	"./Back/Tournament/Teams.vue": [
		"25d9",
		"view-Back-Tournament-Teams-vue"
	],
	"./Back/User/FavouriteTeams.vue": [
		"b2af",
		"view-Back-User-FavouriteTeams-vue"
	],
	"./Back/User/FavouriteTournaments.vue": [
		"5163",
		"view-Back-User-FavouriteTournaments-vue"
	],
	"./Back/User/Friends.vue": [
		"1d20",
		"view-Back-User-Friends-vue"
	],
	"./Back/User/Invitations.vue": [
		"d568",
		"view-Back-User-Invitations-vue"
	],
	"./Back/User/Messages.vue": [
		"88d9",
		"view-Back-User-Messages-vue"
	],
	"./Back/User/Notice/CreateEdit.vue": [
		"2d24",
		"view-Back-User-Notice-CreateEdit-vue"
	],
	"./Back/User/Notice/Delete.vue": [
		"3b3a",
		"view-Back-User-Notice-Delete-vue"
	],
	"./Back/User/Notice/List.vue": [
		"1713",
		"view-Back-User-Notice-List-vue"
	],
	"./Back/User/Notifications.vue": [
		"aa26",
		"view-Back-User-Notifications-vue"
	],
	"./Dashboard.vue": [
		"0c7c",
		"view-Dashboard-vue"
	],
	"./Front.vue": [
		"998a",
		"view-Front-vue"
	],
	"./Front/Division/Assists.vue": [
		"95d8",
		"view-Front-Division-Assists-vue"
	],
	"./Front/Division/Banned.vue": [
		"8e89",
		"view-Front-Division-Banned-vue"
	],
	"./Front/Division/Champions.vue": [
		"5017",
		"view-Front-Division-Champions-vue"
	],
	"./Front/Division/Gks.vue": [
		"ae27",
		"view-Front-Division-Gks-vue"
	],
	"./Front/Division/Liguilla.vue": [
		"a375",
		"view-Front-Division-Liguilla-vue"
	],
	"./Front/Division/Main.vue": [
		"1587",
		"view-Front-Division-Main-vue"
	],
	"./Front/Division/MatchDetail.vue": [
		"76eb",
		"view-Front-Division-MatchDetail-vue"
	],
	"./Front/Division/Mvps.vue": [
		"5851",
		"view-Front-Division-Mvps-vue"
	],
	"./Front/Division/Notices.vue": [
		"e3f5",
		"view-Front-Division-Notices-vue"
	],
	"./Front/Division/RedCards.vue": [
		"f758",
		"view-Front-Division-RedCards-vue"
	],
	"./Front/Division/Results.vue": [
		"bda7",
		"view-Front-Division-Results-vue"
	],
	"./Front/Division/Scorers.vue": [
		"b146",
		"view-Front-Division-Scorers-vue"
	],
	"./Front/Division/Table.vue": [
		"70e6",
		"view-Front-Division-Table-vue"
	],
	"./Front/Division/TeamWeek.vue": [
		"b67c",
		"view-Front-Division-TeamWeek-vue"
	],
	"./Front/Division/Teams.vue": [
		"8bc1",
		"view-Front-Division-Teams-vue"
	],
	"./Front/Division/TheBests.vue": [
		"a94c",
		"view-Front-Division-TheBests-vue"
	],
	"./Front/Division/UpcomingMatches.vue": [
		"3e1f",
		"view-partials-NextMatchs-vue",
		"view-Front-Division-UpcomingMatches-vue"
	],
	"./Front/Division/YellowCards.vue": [
		"3306",
		"view-Front-Division-YellowCards-vue"
	],
	"./Front/Donations.vue": [
		"1d5f",
		"view-Front-Donations-vue"
	],
	"./Front/Home.vue": [
		"63db",
		"view-partials-NextMatchs-vue",
		"view-Front-Home-vue"
	],
	"./Front/Notice.vue": [
		"9063",
		"view-Front-Notice-vue"
	],
	"./Front/Player/Awards.vue": [
		"8bc8",
		"view-Front-Player-Awards-vue"
	],
	"./Front/Player/LastMatches.vue": [
		"626d",
		"view-partials-NextMatchs-vue",
		"view-Front-Player-LastMatches-vue"
	],
	"./Front/Player/Main.vue": [
		"6e6d",
		"view-Front-Player-Main-vue"
	],
	"./Front/Player/Message.vue": [
		"fd08",
		"view-Front-Player-Message-vue"
	],
	"./Front/Player/Notices.vue": [
		"f909",
		"view-Front-Player-Notices-vue"
	],
	"./Front/Player/Record.vue": [
		"29bc",
		"view-Front-Player-Record-vue"
	],
	"./Front/Player/Stats.vue": [
		"dd1b",
		"view-Front-Player-Stats-vue~view-Front-Tournament-Signings-vue",
		"view-Front-Player-Stats-vue"
	],
	"./Front/Team/Awards.vue": [
		"048e",
		"view-Front-Team-Awards-vue"
	],
	"./Front/Team/Fixture.vue": [
		"e7ec",
		"view-partials-NextMatchs-vue",
		"view-Front-Team-Fixture-vue"
	],
	"./Front/Team/LastMatches.vue": [
		"c40f",
		"view-partials-NextMatchs-vue",
		"view-Front-Team-LastMatches-vue"
	],
	"./Front/Team/Main.vue": [
		"e809",
		"view-Front-Team-Main-vue"
	],
	"./Front/Team/Notices.vue": [
		"40e2",
		"view-Front-Team-Notices-vue"
	],
	"./Front/Team/Players.vue": [
		"178d",
		"view-Front-Team-Players-vue"
	],
	"./Front/Team/Scorers.vue": [
		"a0fa",
		"view-Front-Team-Scorers-vue"
	],
	"./Front/Team/TheBests.vue": [
		"6a6d",
		"view-Front-Team-TheBests-vue"
	],
	"./Front/Team/Tournaments.vue": [
		"c448",
		"view-Front-Team-Tournaments-vue"
	],
	"./Front/Team/Training.vue": [
		"dd11",
		"view-Front-Team-Training-vue"
	],
	"./Front/Tournament/Assists.vue": [
		"c4cd",
		"view-Front-Tournament-Assists-vue"
	],
	"./Front/Tournament/Banned.vue": [
		"b0ce",
		"view-Front-Tournament-Banned-vue"
	],
	"./Front/Tournament/Champions.vue": [
		"0eea",
		"view-Front-Tournament-Champions-vue"
	],
	"./Front/Tournament/Divisions.vue": [
		"4638",
		"view-Front-Tournament-Divisions-vue"
	],
	"./Front/Tournament/Gks.vue": [
		"94b0",
		"view-Front-Tournament-Gks-vue"
	],
	"./Front/Tournament/Main.vue": [
		"d475",
		"view-Front-Tournament-Main-vue"
	],
	"./Front/Tournament/Movements.vue": [
		"72ca",
		"view-Front-Tournament-Movements-vue"
	],
	"./Front/Tournament/Mvps.vue": [
		"1348",
		"view-Front-Tournament-Mvps-vue"
	],
	"./Front/Tournament/RankingPlayers.vue": [
		"9b40",
		"view-Front-Tournament-RankingPlayers-vue"
	],
	"./Front/Tournament/RankingTeams.vue": [
		"918b",
		"view-Front-Tournament-RankingTeams-vue"
	],
	"./Front/Tournament/Rules.vue": [
		"8b4a",
		"view-Front-Tournament-Rules-vue"
	],
	"./Front/Tournament/Scorers.vue": [
		"da4b",
		"view-Front-Tournament-Scorers-vue"
	],
	"./Front/Tournament/SellPlayers.vue": [
		"cfb2",
		"view-Front-Tournament-SellPlayers-vue"
	],
	"./Front/Tournament/Signings.vue": [
		"6855",
		"view-Front-Player-Stats-vue~view-Front-Tournament-Signings-vue",
		"view-Front-Tournament-Signings-vue"
	],
	"./Front/Tournament/Teams.vue": [
		"b62f",
		"view-Front-Tournament-Teams-vue"
	],
	"./Front/Tournament/TheBests.vue": [
		"2bab",
		"view-Front-Tournament-TheBests-vue"
	],
	"./Front/Tournament/Transfers.vue": [
		"90fe",
		"view-Front-Tournament-Transfers-vue"
	],
	"./Front/partials/Banners.vue": [
		"2a81",
		"view-Front-partials-Banners-vue"
	],
	"./Front/partials/DropDownTournamentOptions.vue": [
		"824e",
		"view-Front-partials-DropDownTournamentOptions-vue"
	],
	"./Front/partials/MenuDivision.vue": [
		"85b9",
		"view-Front-partials-MenuDivision-vue"
	],
	"./Front/partials/MenuPlayer.vue": [
		"9cc0",
		"view-Front-partials-MenuPlayer-vue"
	],
	"./Front/partials/MenuTeam.vue": [
		"65bf",
		"view-Front-partials-MenuTeam-vue"
	],
	"./Front/partials/MenuTournament.vue": [
		"f649",
		"view-Front-partials-MenuTournament-vue"
	],
	"./Front/partials/ModalCard.vue": [
		"8629",
		"view-Front-partials-ModalCard-vue"
	],
	"./Front/partials/PlayerCard.vue": [
		"167d",
		"view-Front-partials-PlayerCard-vue"
	],
	"./Front/partials/PlayerTraining.vue": [
		"31ab",
		"view-Front-partials-PlayerTraining-vue"
	],
	"./Home.vue": [
		"57da",
		"view-Home-vue"
	],
	"./Main.vue": [
		"2614"
	],
	"./Shop/BetEntry.vue": [
		"d037",
		"view-Shop-BetEntry-vue"
	],
	"./Shop/BetList.vue": [
		"d6ff",
		"view-Shop-BetList-vue"
	],
	"./Shop/Category.vue": [
		"eed9",
		"view-Shop-Category-vue"
	],
	"./Shop/Coins.vue": [
		"b10a",
		"view-Shop-Coins-vue"
	],
	"./Shop/CoinsBuy.vue": [
		"0e8f",
		"view-Shop-CoinsBuy-vue"
	],
	"./Shop/Home.vue": [
		"151f",
		"view-Shop-Home-vue"
	],
	"./Shop/Premium.vue": [
		"ea68",
		"view-Shop-Premium-vue"
	],
	"./Shop/PremiumBuy.vue": [
		"1c75",
		"view-Shop-PremiumBuy-vue"
	],
	"./Shop/Product.vue": [
		"0a19",
		"view-Shop-Product-vue"
	],
	"./Shop/PurchasedProducts.vue": [
		"825b",
		"view-Shop-PurchasedProducts-vue"
	],
	"./Shop/SubCategory.vue": [
		"f290",
		"view-Shop-SubCategory-vue"
	],
	"./Shop/VsDetail.vue": [
		"9116",
		"view-Shop-VsDetail-vue"
	],
	"./Shop/VsEdit.vue": [
		"1213",
		"view-Shop-VsEdit-vue"
	],
	"./Shop/partials/Category.vue": [
		"8fc4",
		"view-Shop-partials-Category-vue"
	],
	"./Shop/partials/Product.vue": [
		"2feb",
		"view-Shop-partials-Product-vue"
	],
	"./partials/CarouselUsersOnline.vue": [
		"a226",
		"view-partials-CarouselUsersOnline-vue"
	],
	"./partials/Footer.vue": [
		"33c7"
	],
	"./partials/ModalSearch.vue": [
		"fc60"
	],
	"./partials/ModalSearchResults.vue": [
		"d07a"
	],
	"./partials/NextMatchs.vue": [
		"f9b2",
		"view-partials-NextMatchs-vue"
	],
	"./partials/RankingPrimary.vue": [
		"593f",
		"view-partials-RankingPrimary-vue"
	],
	"./partials/SideBar.vue": [
		"41b2"
	],
	"./partials/Slider.vue": [
		"f5a5",
		"view-partials-Slider-vue"
	],
	"./partials/TopBar.vue": [
		"27c6"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "0f13";
module.exports = webpackAsyncContext;